import React from 'react';
import { BargainWidgetV1 } from 'app/BargainWidget/Bargains/WidgetV1/BargainWidgetV1';
import { useBargain } from 'app/BargainWidget/context/BargainContext';
import MakeAnOfferButton from 'app/BargainWidget/Bargains/WidgetV1/MakeAnOfferButton';
import { BargainModalV1 } from 'app/BargainWidget/Bargains/WidgetV1/components/BargainModalV1';
import { BargainHistoryV1 } from 'app/BargainWidget/Bargains/WidgetV1/components/BargainHistoryV1';
import BargainAuthV1 from 'app/BargainWidget/Bargains/WidgetV1/components/BargainAuthV1';
import OfferAcceptedV1 from 'app/BargainWidget/Bargains/WidgetV1/components/OfferAcceptedV1';

const WidgetV1 = () => {
  const {
    widgetSettings,
    translation,
    isCustomerLoggedIn,
    modalView,
    handleChangeModalView,
    handleCloseModalView,
    isShowBargainWidgetAndButton
  } = useBargain();

  return isShowBargainWidgetAndButton ? (
    <div className={'bargain-widget-container-v1'}>
      {widgetSettings?.launcherType === 'OFFER_WIDGET' && <BargainWidgetV1 isAuthenticated={isCustomerLoggedIn} className={''} />}
      {widgetSettings?.launcherType === 'OFFER_BUTTON' && <MakeAnOfferButton onClick={() => handleChangeModalView('widget')} />}
      <BargainModalV1 isOpen={modalView !== null} onClose={handleCloseModalView} className={'bargain-widget-modal-v1'}>
        {modalView === 'widget' && <BargainWidgetV1 isAuthenticated={isCustomerLoggedIn} className={''} />}
        {(modalView === 'auth' || modalView === 'history' || modalView === "offer_accepted") && (
          <div className="se-bg-white se-rounded-lg se-overflow-hidden se-w-[350px] bargain-widget-modal-v1-content-wrapper">
            <div
              style={
                {
                  '--header-background-color': widgetSettings?.headerBackgroundColor || '#000000',
                  '--heading-text-color': widgetSettings?.contentTextColor || '#ffffff',
                } as any
              }
              className="se-bg-gradient-to-br se-bg-[var(--header-background-color)] se-text-[var(--heading-text-color)] se-p-4 bargain-widget-modal-v1-content-header"
            >
              <button
                onClick={() => handleChangeModalView('widget')}
                className="se-text-white hover:se-text-white/80 se-text-sm se-font-medium bargain-widget-modal-v1-back-action-button"
              >
                {translation?.backToOfferText || '← Back to Offer'}
              </button>
            </div>
            <div className="se-p-4 bargain-widget-modal-v1-content-body">
              {modalView === 'auth' && <BargainAuthV1 />}
              {modalView === 'history' && <BargainHistoryV1 />}
              {modalView === 'offer_accepted' && <OfferAcceptedV1 />}
            </div>
          </div>
        )}
      </BargainModalV1>
    </div>
  ) : null;
};

export default WidgetV1;
